import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  loadAccounts,
  loadBenefitPlans,
  loadClaimItems,
  getEmployeesByDelegation,
} from "actions/claimActions";
import {
  groupItemsByCategory,
  getAllBenefitPlans,
  getDefaultBenefitPlan,
  getBenefitPlan,
  getAccountsById,
  getAllEmployeeByDelegation,
  getDefaultDelegateEmployeeId,
} from "reducers/claimsReducer";
import { formValueSelector } from "redux-form";
import ClaimItemSelectionForm, { formName } from "./ClaimItemSelectionForm";
import { Card, CardSection, Loader, Button } from "cxa-components";
import AccountsList from "components/claim/AccountsList";
import { enrichAccounts } from "./util";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { getShortLivedToken } from "actions/loginActions";
import { showPopup } from "actions/popupActions";
import { renderVideoOnNewWindow } from "utils/html";
class ClaimItemSelectionPage extends React.Component {
  state = {
    isFetching: true,
  };

  componentDidMount() {
    const { getEmployeesByDelegation } = this.props;

    getEmployeesByDelegation().then(() => {
      const {
        loadClaimItems,
        loadAccounts,
        loadBenefitPlans,
        benefitPeriod,
        benefitPlan,
        delegateToEmployeeId,
        getDonateCategory,
      } = this.props;

      loadBenefitPlans();

      if (benefitPeriod) {
        // delegateToEmployeeId - optional param
        loadClaimItems(benefitPeriod, false, delegateToEmployeeId, getDonateCategory);
        loadAccounts(benefitPeriod, benefitPlan.planEnd, null, delegateToEmployeeId);
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      loadClaimItems,
      loadAccounts,
      benefitPeriod,
      benefitPlan,
      delegateToEmployeeId = null,
      getDonateCategory,
    } = this.props;
    const isClaimOrDelegationChange =
      prevProps.benefitPeriod !== benefitPeriod ||
      prevProps.delegateToEmployeeId !== delegateToEmployeeId;
    if (isClaimOrDelegationChange && benefitPeriod !== null) {
      loadClaimItems(benefitPeriod, false, delegateToEmployeeId, getDonateCategory);
      loadAccounts(benefitPeriod, benefitPlan.planEnd, null, delegateToEmployeeId);
    } else if (prevProps.isFetching && !this.props.isFetching) {
      this.setState({
        isFetching: false,
      });
    }
  }

  render() {
    const {
      onSubmitSelection,
      accounts = [],
      pageFields,
      login,
      claimNotes,
      intl,
      delegateToEmployeeId,
      helpSettings,
      getDonateCategory,
      ...props
    } = this.props;

    const videos = (helpSettings.items || []).filter(item => item.title === "Claims") || [];

    const showHelpVideo = () => {
      renderVideoOnNewWindow(videos[0].url);
    };
    const claimNotesForDisplay = claimNotes
      ? intl.formatMessage({ id: "config.donationClaimNotes", defaultMessage: claimNotes })
      : `<sup>*</sup>${intl.formatMessage(messages.claimNotesForDisplayDescription)}`;

    return this.state.isFetching ? (
      <Loader />
    ) : (
      <div>
        <h2>
          {intl.formatMessage(
            getDonateCategory
              ? messages.submitNewDonationDescription
              : messages.submitNewClaimDescription
          )}
        </h2>
        <p>
          {intl.formatMessage(
            getDonateCategory
              ? messages.selectItemToStartDonationDescription
              : messages.selectItemToStartDescription
          )}
        </p>
        <div className="cxa-grid__wrapper apl-claims__selection apl-grid--wrapped">
          <div className="cxa-grid__item cxa-grid__item--six">
            <Card>
              <CardSection>
                {videos.length > 0 && videos[0].url && (
                  <Button
                    type="button"
                    className="u-margin-bottom"
                    onClick={showHelpVideo}
                    style={{ height: "60px", float: "right" }}
                  >
                    {intl.formatMessage(messages.watchTutorialText)}
                  </Button>
                )}
                <ClaimItemSelectionForm
                  onSubmit={onSubmitSelection}
                  functionReferenceId="Submission"
                  selectedDelegator={delegateToEmployeeId}
                  getDonateCategory={getDonateCategory}
                  {...props}
                />
                <div dangerouslySetInnerHTML={{ __html: claimNotesForDisplay }} />
              </CardSection>
            </Card>
          </div>
          <div className="cxa-grid__item cxa-grid__item--six">
            <AccountsList
              rows={enrichAccounts(accounts, login)}
              columns={pageFields}
              selectedDelegator={delegateToEmployeeId}
              getDonateCategory={getDonateCategory}
            />
          </div>
        </div>
      </div>
    );
  }
}

ClaimItemSelectionPage.propTypes = {
  benefitPlans: PropTypes.array, //this value is from backend ClaimItems api
  benefitPlan: PropTypes.any,
  benefitPeriod: PropTypes.any,
  isFetching: PropTypes.any,
  claimItems: PropTypes.array,
  claimNotes: PropTypes.string,
  isCPFEnabled: PropTypes.bool,
  accounts: PropTypes.array,
  pageFields: PropTypes.array,
  login: PropTypes.object,
  onSubmitSelection: PropTypes.func,
  loadClaimItems: PropTypes.func,
  loadBenefitPlans: PropTypes.func,
  loadAccounts: PropTypes.func,
  messages: PropTypes.object,
  intl: intlShape.isRequired,
  getShortLivedToken: PropTypes.func,
  getEmployeesByDelegation: PropTypes.func,
  showPopup: PropTypes.func,
  delegateToEmployeeId: PropTypes.string,
  helpSettings: PropTypes.object,
  getDonateCategory: PropTypes.bool,
};

const mapStateToProps = (state, { push }) => {
  const {
    claims: {
      accounts,
      claimItems,
      claimItemGroups,
      claimItemCategories,
      claimPlanYears,
      benefitPlans,
      employeesByDelegation: employeesDelegation,
    },
    login,
    needhelp: { response },
  } = state;

  const selector = formValueSelector(formName);
  const claimItemId = selector(state, "claimTypeId");
  const defaultPlanId = getDefaultBenefitPlan(benefitPlans) || null;
  const benefitPeriod = selector(state, "benefitPeriod") || defaultPlanId;
  const benefitPlan = getBenefitPlan(benefitPlans, benefitPeriod);
  const employeesByDelegation = getAllEmployeeByDelegation(employeesDelegation);
  const isEmployeesByDelegationEnabled = employeesByDelegation.length > 0;
  const defaultDelegateEmployeeId = getDefaultDelegateEmployeeId(employeesDelegation) || null;
  const delegateToEmployeeId =
    selector(state, "employeesByDelegation") || defaultDelegateEmployeeId;

  return {
    login,
    accounts: getAccountsById(accounts, benefitPeriod),
    pageFields: accounts.pageFields,
    benefitPeriod,
    claimItemId,
    claimItems: groupItemsByCategory(claimItemGroups, claimItemCategories, claimItems),
    claimNotes: claimItems.claimNotes,
    isCPFEnabled: claimItems.isCPFEnabled,
    benefitPlan,
    benefitPlans: getAllBenefitPlans(claimPlanYears),
    defaultPlanId,
    employeesByDelegation,
    isEmployeesByDelegationEnabled,
    delegateToEmployeeId,
    initialValues: {
      benefitPeriod: defaultPlanId,
    },
    isFetching: claimItems.isFetching,
    onSubmitSelection: ({ benefitPeriod, claimTypeId }) =>
      push(`/claims/submit/${claimTypeId}/${benefitPeriod}`),
    helpSettings: response,
  };
};

const mapDispatchToProps = {
  loadClaimItems,
  loadBenefitPlans,
  loadAccounts,
  getShortLivedToken,
  getEmployeesByDelegation,
  showPopup,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ClaimItemSelectionPage));



// WEBPACK FOOTER //
// ./components/claim/ClaimItemSelectionPage.js